import { createContext } from 'use-context-selector';

export interface TenantSettingsContextInterface {
  setUnsavedChanges: (key: string, value: boolean) => void;
}

const defaultValues: TenantSettingsContextInterface = {
  setUnsavedChanges: () => undefined,
};
export const UnsavedChangesContext = createContext(defaultValues);

export enum TenantSettingsKeys {
  'General' = 'general',
  'AutoLogout' = 'logout',
  'Calendar' = 'calendar',
  'GDT' = 'gdt',
  'HL7' = 'hl7',
  'MeasurementImport' = 'import',
  'PasswordValidation' = 'password',
  'Audit' = 'audit',
}

export enum SubtenantSettingsKeys {
  'MailService' = 'mail',
}
